import { Dialog, Grid, IconButton } from "@mui/material";
import React, { useContext, useState } from "react";
import MuiDialogTitle from "@mui/material/DialogTitle";
import { useTranslation } from "react-i18next";
import CloseIcon from "@mui/icons-material/Close";
import MyContext from "../../../contexts/MyContext";
import { AddReceipt } from "./AddReceipt";

export const AddAccommodationReceiptDialog = (props) => {
  const { t } = useTranslation();
  const myContext = useContext(MyContext);
  // const [receipt, setReceipt] = useState([]);
  const handleSave = (receipt, totalCost) => {
    // setReceipt(receipt);
    myContext.changeAccommodationReceipt(receipt);
    myContext.changeAccommodationTotalCost(totalCost);
    props.onClose();
  };
  return (
    <MyContext.Consumer>
      {(context) => (
        <Dialog fullScreen open={props.open} onClose={props.onClose}>
          <MuiDialogTitle component="span">
            <IconButton aria-label={t("close")} style={{ float: "right" }} onClick={props.onClose}>
              <CloseIcon />
            </IconButton>
          </MuiDialogTitle>
          <Grid container justifyContent="center" className="container custom">
            <Grid item className="padding left-1 right-1">
              <h2>{t("add_receipt_for_expenses")}</h2>
              <p className="margin bottom-0">{t("add_all_receipts_for_accommodation")}</p>
              <p>
                <small>{t("max_25MB_per_file")}</small>
              </p>
              <AddReceipt totalCost={context.accommodationTotalCost} onSave={handleSave} receipt={context.accommodationReceipt} {...props} />
            </Grid>
          </Grid>
        </Dialog>
      )}
    </MyContext.Consumer>
  );
};
